import { WarningIcon } from '@phosphor-icons/react'

import * as Styles from './styles'

export const productsCardTabs = {
  allProducts: 'allProducts',
  sizingIssues: 'sizingIssues',
}

export const getTabs = (t, productsCount, sizeRecommendationsCount) => [
  {
    value: productsCardTabs.allProducts,
    label: `${t('Todos los productos')} (${productsCount})`,
  },
  {
    value: productsCardTabs.sizingIssues,
    label: (
      <Styles.TabLabel>
        <WarningIcon size={16} />
        {`${t('Problemas de talla')} (${sizeRecommendationsCount})`}
      </Styles.TabLabel>
    ),
  },
]
